function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToggleOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 16
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.566)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 16,
  "data-name": "Rectangle 132",
  rx: 8,
  style: {
    fill: "#969696"
  },
  transform: "translate(.566)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  "data-name": "Rectangle 133",
  rx: 6,
  style: {
    fill: "#fff"
  },
  transform: "translate(2.566 2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.2 3.2 0 6.4l3.2-3.2L0 0l3.2 3.2L6.4 0 3.2 3.2l3.2 3.2z",
  style: {
    fill: "none",
    stroke: "#fff"
  },
  transform: "translate(27.8 4.8)"
}));
export { SvgToggleOff as ReactComponent };
export default __webpack_public_path__ + "images/Toggle_Off.24b2b7f2.svg";